import {
  setFloor,
  setFloorKey,
  setLocationKey,
  setSection,
  setSectionKey,
} from './locationSlice';

export const setLocation = (key, floor, section, floorKey, sectionKey) => {
  return (dispatch) => {
    dispatch(setLocationKey(key));
    dispatch(setFloorKey(floorKey));
    dispatch(setSectionKey(sectionKey));
    dispatch(setFloor(floor));
    dispatch(setSection(section));
  };
};
